import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import UserLabTestItem from './user-lab-test-item';
import UserLabTestItemDetail from './user-lab-test-item-detail';
import UserLabTestItemUpdate from './user-lab-test-item-update';
import UserLabTestItemDeleteDialog from './user-lab-test-item-delete-dialog';

const UserLabTestItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<UserLabTestItem />} />
    <Route path="new" element={<UserLabTestItemUpdate />} />
    <Route path=":id">
      <Route index element={<UserLabTestItemDetail />} />
      <Route path="edit" element={<UserLabTestItemUpdate />} />
      <Route path="delete" element={<UserLabTestItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default UserLabTestItemRoutes;
